module.exports = __webpack_public_path__ + "static/media/7S.f66c3343.svg";